module.exports = __webpack_public_path__ + "static/fair-harbor@abonventre.d498f190.jpg";